import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingBlockHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();

  if (!flow?.isCompleted && currentStep?.id as OnboardingSteps === "navigate") {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.blockHint}
          defaultOpen={true}
          side="right"
          align="start"
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingBlockHintFlow;